import * as Sentry from '@sentry/react';

export default function initSentry() {
  if (!process.env.REACT_APP_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: window.location.hostname,
    release: `ftrprf-platform@${process.env.REACT_APP_VERSION}`,
  });
}
